import { ReactElement } from 'react';

import { Tooltip } from '@atom/mui';

import ADOTGroupMembersList from './ADOTGroupMembersList';

type ADOTGroupMembersTooltipProps = {
  groupId: string;
  children: ReactElement;
};

const ADOTGroupMembersTooltip = ({
  groupId,
  children,
}: ADOTGroupMembersTooltipProps) => (
  <Tooltip
    lightTooltip
    placement="bottom-start"
    title={<ADOTGroupMembersList groupId={groupId} />}
  >
    {children}
  </Tooltip>
);

export default ADOTGroupMembersTooltip;
